import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { ClearedStyleRouterLink } from "@modules/Components";
import { getSellCardsArray } from "@modules/Sell/selector";
import MailInStatusBar from "@components/MailInStatusBar";

const SellCardsContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: #f9f9f9;
`;

const InnerContainer = styled.div`
  max-width: 85%;
  margin: 0 auto;
  padding-top: 35px;
  padding-bottom: 35px;

  @media (max-width: 430px) {
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;

  @media (max-width: 315px) {
    grid-template-columns: auto auto;
  }
`;

const HeaderText = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 2;
  color: #1f2021;

  @media (max-width: 465px) {
    font-size: 16px;
  }
  @media (max-width: 400px) {
    font-size: 15px;
  }
  @media (max-width: 335px) {
    font-size: 14px;
  }
  @media (max-width: 310px) {
    font-size: 13px;
  }
`;

const LinkContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  color: #12b2ea;
  justify-self: flex-end;

  @media (max-width: 335px) {
    font-size: 12px;
  }
  @media (max-width: 300px) {
    font-size: 10px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  margin-top: 25px;
`;

const Image = styled.img`
  width: 56px;
  height: 36px;
  margin-right: 29px;
`;

const ExtraCardContainer = styled.span`
  width: 56px;
  height: 36px;
  border-radius: 2.7px;
  background-color: rgba(119, 121, 132, 0.12);
  font-size: 14px;
  font-weight: bold;
  line-height: 1.71;
  text-align: center;
  color: #777984;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SellCardsDetails = ({ orderInfo }) => {
  const getAmount = () => {
    return globalThis.innerWidth > 530
      ? 4
      : globalThis.innerWidth > 400
      ? 3
      : globalThis.innerWidth > 300
      ? 2
      : 1;
  };
  const [amountToSlice, changedAmountToSlice] = useState(getAmount());

  const handleResize = () => {
    changedAmountToSlice(getAmount());
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <SellCardsContainer>
      <InnerContainer>
        <Header>
          <HeaderText>Submitted Cards</HeaderText>
          <LinkContainer>
            <ClearedStyleRouterLink to="/step-two/">
              Back to Cards
            </ClearedStyleRouterLink>
          </LinkContainer>
        </Header>
        <ImageContainer>
          {orderInfo.slice(0, amountToSlice).map((card, index) => (
            <Image key={index} src={card.img} alt="card" />
          ))}
          {orderInfo.length > amountToSlice && (
            <ExtraCardContainer>
              +{orderInfo.length - amountToSlice}
            </ExtraCardContainer>
          )}
        </ImageContainer>
      </InnerContainer>
      <MailInStatusBar
        borderRadius={"0px 0px 10px 10px"}
        backgroundColor={"rgba(119, 121, 132, 0.06)"}
        isCheckout
      />
    </SellCardsContainer>
  );
};

export default connect(state => ({
  cards: state.cards,
  orderInfo: getSellCardsArray({
    merchants: state.merchantsSell,
    cards: state.cards,
    trade: state.cartSell.tradeBonus
  })
}))(SellCardsDetails);
